var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",style:({
    'background': _vm.formatObjStatus(_vm.status).background,
    'color': _vm.formatObjStatus(_vm.status).color,
    'border-color': _vm.formatObjStatus(_vm.status).borderColor
  })},[_vm._v(" "+_vm._s(_vm.formatObjStatus(_vm.status).label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }